import { createSelector } from 'reselect';
import { PropTypes } from 'preact-compat';
import { actionTypes } from '../actions';

export const moduleName = 'countries';

export const countryShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  localName: PropTypes.string.isRequired,
  searchTerms: PropTypes.string.isRequired,
});

// Reducer (down)

const initialState = {
  fetched: false,
  error: '',
  entities: [],
};

export default function reducer(state = initialState, action) {
  const { error, type, payload } = action;

  switch (type) {
    case actionTypes.COUNTRIES_FETCH_REQUEST:
      return {
        ...state,
        fetched: false,
        error: initialState,
        entities: initialState.entities,
      };

    case actionTypes.COUNTRIES_FETCH_SUCCESS: {
      const { countriesList } = payload;

      return {
        ...state,
        fetched: true,
        error: initialState.error,
        entities: countriesList,
      };
    }

    case actionTypes.COUNTRIES_FETCH_FAILURE:
      return {
        ...state,
        error,
        fetched: false,
        entities: initialState.entities,
      };

    default:
      return state;
  }
}

// Reducer (up)

// Selectors (down)

const stateSelector = (store) => store[moduleName];

export const selectCountriesIsFetched = createSelector(stateSelector, (countries) => (
  countries.fetched
));

export const selectCountries = createSelector(stateSelector, (countries) => countries.entities);

export const selectCountriesForSelect = createSelector(selectCountries, (countries) => countries.map((country) => ({
  ...country,
  label: country.displayName,
  value: country.code,
})));

// Selectors (up)



// WEBPACK FOOTER //
// ./reducers/countries.js